module.exports = __webpack_public_path__ + "media/images/icon-blog-f3288765eb39023c373a6106e0dd2da9.svg";